module.exports = "https://cdn2-fs.clearscore.com/flux/images/6ab24f0cd89d75c5cd4e4503ea3c7d2e.jpg";